import { FieldValidation, ValidationResult } from '@/lib/utils/submitValidation';

/**
 * Validates required-to-save fields.
 * Mirrors submit validation behavior, but with save-specific default messages.
 */
export function validateRequiredToSave(fields: FieldValidation[]): ValidationResult {
  const errors: string[] = [];
  const fieldErrors: Record<string, string> = {};

  for (const field of fields) {
    if (field.validator) {
      const validationResult = field.validator(field.value);
      if (typeof validationResult === 'string') {
        const errorMsg = `${field.label}: ${validationResult}`;
        errors.push(errorMsg);
        fieldErrors[field.key] = validationResult;
        continue;
      }
      if (validationResult === false) {
        const errorMsg = `${field.label} is invalid`;
        errors.push(errorMsg);
        fieldErrors[field.key] = errorMsg;
        continue;
      }
      continue;
    }

    if (!field.hasValue) {
      const errorMsg = `${field.label} is required to save`;
      errors.push(errorMsg);
      fieldErrors[field.key] = errorMsg;
    }
  }

  return {
    isValid: errors.length === 0,
    errors,
    fieldErrors,
  };
}
